import { render, staticRenderFns } from "./Tier.vue?vue&type=template&id=0aecd8e7"
import script from "./Tier.vue?vue&type=script&lang=js"
export * from "./Tier.vue?vue&type=script&lang=js"
import style0 from "./Tier.vue?vue&type=style&index=0&id=0aecd8e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports